import React from 'react';
import { motion } from 'framer-motion';
export function OpeningLead() {
  return <section className="bg-white px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-138">
      <div className="mx-auto max-w-3xl" data-id="element-139">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} data-id="element-140">
          <h2 className="mb-8 text-center font-serif text-5xl font-bold italic text-[#2D2D2D] sm:text-6xl lg:text-7xl" data-id="element-141">
            It's 3:00 AM.
          </h2>

          <div className="space-y-6 font-sans text-xl leading-loose text-[#2D2D2D]/90" data-id="element-142">
            <p data-id="element-143">
              The house is dark. The baby is finally breathing slowly. And
              you're standing in front of a mirror you've started to avoid.
            </p>
            <p data-id="element-144">
              You're not crying about your weight. You're crying because you
              don't recognize the woman looking back at you.
            </p>
            <p data-id="element-145">
              She looks tired in a way sleep can't fix. She looks like she's
              been pouring herself into everyone else for so long that she's not
              sure there's anything left. She looks like someone who used to
              have a name — and now goes by "Mom."
            </p>
            <p data-id="element-146">
              You tell yourself it's fine. That this is what sacrifice looks
              like. That good mothers put themselves last.
            </p>
            <p data-id="element-147">
              But late at night, when the noise stops — a question surfaces that
              you don't dare say out loud:
            </p>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="my-8 border-l-4 border-[#D4603A] py-2 pl-8" data-id="element-148">
              <p className="font-serif text-3xl font-bold italic text-[#D4603A]" data-id="element-149">
                Where did I go?
              </p>
            </motion.div>

            <p data-id="element-150">
              If you've asked yourself that question even once, you're in
              exactly the right place.
            </p>
            <p data-id="element-151">
              Because that question isn't weakness. It's not vanity. It's not
              selfishness.
            </p>
            <p className="font-bold text-[#2D2D2D]" data-id="element-152">
              It's your identity fighting to survive.
            </p>
            <p data-id="element-153">
              And everything you're about to read was written for the exact
              moment you're in right now.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}